import { Moment } from 'moment';
import { apiGet, API_URI } from './index';

const mentions = {
    getAll: async (projectId: number, dateFrom: Moment, dateTo: Moment, streamIds: number[]) => {
        const data = await apiGet(`${API_URI}/api/mentions/getall?projectId=${projectId}&startDate=${dateFrom.format("DD MMM YYYY HH:mm")}&endDate=${dateTo.format("DD MMM YYYY HH:mm")}&streamIds=${streamIds.join(',')}`);
        return data;
    }
}

export default mentions;